import { axiosBearerSite } from "../api";

const carrerService = {
  registerAnalysis: async (type, route) => {
    await axiosBearerSite.post("site/com.levty/levtyFacade/registerAnalysis", {
      type: type,
      route: route,
    }).catch(err => {
      console.log(err);
    });
  },
  getSelectiveProcess: async () => {
    const sps = await axiosBearerSite.post("site/com.sydle.hr_recruiter/serviceFacade/selectiveProcess", {})
      .then(response => {
        if (response.status === 200) {
          return prepareSelectiveProcess(response.data.sps);
        }
      })
      .catch(err => {
        console.log(err);
      });
    return sps;
  },
  getTraineeSelectiveProcess: async (data) => {
    const trainee = await axiosBearerSite.post("site/com.sydle.hr_recruiter/serviceFacade/traineeSelectiveProcess", data)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
    return trainee;
  },
  getJobDescription: async (data) => {
    const job = await axiosBearerSite.post("site/com.sydle.hr_recruiter/serviceFacade/getJobDescription", data)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
    return job;
  },
  selectiveProcessSubscribe: async (data) => {
    try {
      const response = await axiosBearerSite.post("site/com.sydle.hr_recruiter/serviceFacade/selectiveProcessSubscribe", data);
      return { result: response, error: null };
    } catch (error) {
      console.error(error);
      return { result: null, error: error };
    }
  },
  submitResume: async (data) => {

    const result = await axiosBearerSite.post("site/com.sydle.hr_recruiter/serviceFacade/submitResume", data)
      .then(response => {
        return (response.status === 200);
      })
      .catch(err => {
        console.log(err);
        return false;
      });
    return result;
  },
  getJobJsonld: async (data) => {

    const result = await axiosBearerSite.post("site/com.sydle.hr_recruiter/serviceFacade/selectiveProcessJSONLD", data)
      .then(response => {
        if (response.status === 200) {
          return response.data.jsonld;
        }
      })
      .catch(err => {
        console.log(err);
        return false;
      });
    return result;
  }
}

// --- Funções auxiliares -------------------------------------------------------------------------------

function prepareSelectiveProcess(sps) {
  // Agrupa por nome da cidade({ Key: Value })
  let remoteJobs = [];
  sps = sps.groupBy("cityName");
  let cities = Object.keys(sps);

  (cities || []).forEach(city => {
    (sps[city] || []).forEach((sp, index) => {
      if (sp.isRemoteJob) {
        remoteJobs.push(sp);
        sps[city].splice(index, 1);
      }
    });

  });

  if (remoteJobs.length) {
    var newObj = {};
    sps["Remoto"] = remoteJobs;
    Object.keys(sps).sort((a, b) => {
      if (a === "Remoto") return -1;
      if (b === "Remoto") return 1;
      return 0;
    }).forEach(e => {
      newObj[e] = sps[e];
    });
    sps = newObj;
  }

  return sps;
}

export default carrerService;